import { render, staticRenderFns } from "./ChallengesBoutique.vue?vue&type=template&id=5f9622e5&"
import script from "./ChallengesBoutique.vue?vue&type=script&lang=js&"
export * from "./ChallengesBoutique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports